import { message } from "antd";
import { useEffect, useRef, useState } from "react";
import { connectTikTok } from "services/SauceService";
import "./TikTokAuth.scss";
import { TIKTOK_AUTH_REFRESH_EVENT_KEY } from "constants/tiktok";

const TikTokAuthContainer: React.FC<{
  status: "idle" | "loading" | "success" | "error";
}> = ({ status }) => {
  if (status === "loading") {
    return (
      <div className="tiktok-auth__layout">
        <h2>Connecting to TikTok</h2>
        <p>Please wait while we process your authentication…</p>
      </div>
    );
  }

  if (status === "success") {
    return (
      <div className="tiktok-auth__layout">
        <h2>All set!</h2>
        <p>
          Your TikTok connection is complete. This window will close shortly.
        </p>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="tiktok-auth__layout">
        <h2>Something went wrong</h2>
        <p>We couldn’t complete the authentication. Please try again.</p>
      </div>
    );
  }

  return (
    <div className="tiktok-auth__layout">
      <h2>Redirecting…</h2>
      <p>Hold on while we prepare your authentication.</p>
    </div>
  );
};

const TikTokAuth: React.FC = () => {
  const [status, setStatus] = useState<
    "idle" | "loading" | "success" | "error"
  >("idle");
  const hasHandledRef = useRef(false);

  useEffect(() => {
    const handleAuth = async () => {
      if (hasHandledRef.current) return;
      hasHandledRef.current = true;
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");

      if (code) {
        setStatus("loading");
        try {
          const params = {
            accessToken: code,
            businessId: localStorage.getItem("businessId"),
          };
          await connectTikTok(params);

          localStorage.setItem(
            TIKTOK_AUTH_REFRESH_EVENT_KEY,
            Date.now().toString()
          );

          setStatus("success");
        } catch (error) {
          console.error("Error during authentication:", error);
          message.error("Error during authentication");
          setStatus("error");
        }
      } else {
        console.error("No code found in URL");
        setStatus("error");
      }
    };

    handleAuth();
  }, []);

  useEffect(() => {
    if (status === "success") {
      const timeoutId = window.setTimeout(() => {
        window.close();
      }, 5000);

      return () => window.clearTimeout(timeoutId);
    }

    return undefined;
  }, [status]);

  return <TikTokAuthContainer status={status} />;
};

export default TikTokAuth;
